import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';

import * as datetime from 'legacy/common/utils/datetime';

const EventDate = ({ startDate, endDate, activeStatus }) => {
  const formattedStartDate = datetime.format(startDate, 'dddd, MMM Do, YYYY');
  const formattedStartTime = datetime.format(startDate, 'hh:mm A');
  const isStartEndSameDate = endDate
    ? datetime.isSame(startDate, endDate, 'day')
    : true;
  const formattedEndDate =
    endDate && datetime.format(endDate, 'dddd, MMM Do, YYYY');
  const formattedEndTime = endDate && datetime.format(endDate, 'hh:mm A');

  if (activeStatus === 'past') {
    return (
      <p className="pt-[4px] text-lg text-gray-500 flex items-center">
        <FaCheckCircle className="mr-2" />
        Event has passed!
      </p>
    );
  }

  if (isStartEndSameDate) {
    return (
      <div className="pt-[4px] text-xl text-gray-600 font-normal">
        {`${formattedStartDate} • ${formattedStartTime}`}
        {formattedEndTime && ` - ${formattedEndTime}`}
      </div>
    );
  }

  return (
    <div className="pt-[4px] flex flex-col gap-2 text-gray-600">
      <div>
        <p className="text-base">Starts</p>
        <div className="text-xl text-gray-600 font-normal">
          {formattedStartDate} • {formattedStartTime}
        </div>
      </div>
      <div>
        <p className="text-base">Ends</p>
        <div className="text-xl text-gray-600 font-normal">
          {formattedEndDate} • {formattedEndTime}
        </div>
      </div>
    </div>
  );
};

export default EventDate;
